import { useMemo } from "react";
import { cartBundleSelectionsToCombination } from "../core/bundle.core";
import productCore from "../core/product.core";
import { CartItem } from "../types/cart";
import useGetBundleSelectionInventory from "./useGetBundleSelectionInventory.hook";
import useProductSingle from "./productSingle.hook";

const GIFT_CARD_MAX_QUANTITY = 9999;

export default function useGetCartItemInventory(item: CartItem): number | undefined {
  const { product, bundleSelections } = item;
  const isBundle = product.productType === "bundle";

  const selectedBundle = useMemo(() => {
    if (!isBundle || !bundleSelections) return undefined;
    return cartBundleSelectionsToCombination(product, bundleSelections);
  }, [isBundle, product, bundleSelections]);

  const { data: freshProduct, isLoading: isProductLoading } = useProductSingle(!isBundle ? product.id : null);
  const bundleInventory = useGetBundleSelectionInventory(selectedBundle);

  if (product.productType === "giftCard") {
    return GIFT_CARD_MAX_QUANTITY;
  }

  if (isBundle) {
    if (bundleInventory === undefined) return undefined;
    return bundleInventory;
  }

  if (isProductLoading && !freshProduct) {
    return undefined;
  }

  const productForInventory = freshProduct ?? product;
  return productCore.getSimpleProductInventoryCount(productForInventory);
}
